import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/shared/components/ui/navigation-menu"
import { NavLink, useLocation } from "react-router-dom"

interface NavigationProps {
  isWhiteBackground?: boolean
}

const Navigation = ({ isWhiteBackground = false }: NavigationProps) => {
  const { pathname } = useLocation()
  
  // Enhanced Services active detection - includes more service-related routes
  const isServicesActive = pathname.startsWith("/destination") || 
                          pathname.startsWith("/destinations") || 
                          pathname.startsWith("/visa") ||
                          pathname.startsWith("/packages") ||
                          pathname.startsWith("/travel") ||
                          pathname.startsWith("/service")
  
  const isAboutActive = pathname.startsWith("/about") || pathname.startsWith("/fly-and-share")
  
  // Debug logging to help identify the current path
  // console.log('Current pathname:', pathname, 'isServicesActive:', isServicesActive)

  return (
    <NavigationMenu>
      <NavigationMenuList className="space-x-6 md:space-x-4">
        <NavigationMenuItem>
          <NavigationMenuLink asChild>
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `transition-smooth nav-item font-medium ${isActive ? "text-orange-500" : isWhiteBackground ? "text-gray-900" : "text-current"}`
              }
            >
              Home
            </NavLink>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger 
            className={`bg-transparent transition-smooth nav-item hover:bg-transparent focus:bg-transparent data-[state=open]:bg-transparent data-[state=open]:text-amber-700 focus:text-amber-700 font-medium ${
              isServicesActive ? "text-amber-700" : isWhiteBackground ? "text-gray-900" : "text-current"
            }`}
            style={{ 
              backgroundColor: 'transparent',
              color: isServicesActive ? '#f59e0b' : undefined
            }}
          >
            Services
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 md:w-[280px] lg:w-[350px] p-4 dropdown-fade-in">
              <li>
                <NavigationMenuLink asChild>
                  <NavLink
                    to="/destination"
                    className={({ isActive }) =>
                      `transition-smooth nav-item ${isActive ? "text-orange-500" : ""}`
                    }
                  >
                    <p className="font-bold transition-smooth">International & Domestics</p>
                    <p className="text-sm text-gray-500">
                      Explore international, domestic, and cruise travel experiences
                    </p>
                  </NavLink>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <NavLink
                    to="/visa"
                    className={({ isActive }) =>
                      `transition-smooth nav-item ${isActive ? "text-orange-500" : ""}`
                    }
                  >
                    <p className="font-bold transition-smooth">Visa & Travel Insurance</p>
                    <p className="text-sm text-gray-500">
                      Hassle-free visa assistance and reliable travel insurance for a smooth, worry-free journey.
                    </p>
                  </NavLink>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger 
            className={`bg-transparent transition-smooth nav-item hover:bg-transparent focus:bg-transparent data-[state=open]:bg-transparent data-[state=open]:text-amber-700 focus:text-amber-700 font-medium ${
              isAboutActive ? "text-amber-700" : isWhiteBackground ? "text-gray-900" : "text-current"
            }`}
            style={{ 
              backgroundColor: 'transparent',
              color: isAboutActive ? '#b45309' : undefined
            }}
          >
            About Us
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 md:w-[280px] lg:w-[350px] p-4 dropdown-fade-in">
              <li>
                <NavigationMenuLink asChild>
                  <NavLink
                    to="/about"
                    className={({ isActive }) =>
                      `block p-3 rounded-md transition-smooth nav-item ${
                        isActive ? "text-orange-500" : ""
                      }`
                    }
                  >
                    <p className="font-bold transition-smooth">Who We Are?</p>
                    <p className="text-sm text-gray-500">Learn more about our mission and travel expertise</p>
                  </NavLink>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <NavLink
                    to="/fly-and-share"
                    className={({ isActive }) =>
                      `block p-3 rounded-md transition-smooth nav-item ${
                        isActive ? "text-orange-500" : ""
                      }`
                    }
                  >
                    <p className="font-bold transition-smooth">Fly & Share</p>
                    <p className="text-sm text-gray-500">Empowering students with educational resources and hope</p>
                  </NavLink>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink asChild>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `transition-smooth nav-item font-medium ${isActive ? "text-orange-500" : isWhiteBackground ? "text-gray-900" : "text-current"}`
              }
            >
              Contact
            </NavLink>
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  )
}

export default Navigation
